import { Translate } from '@dreryk/react-common';
import { TextView } from '@dreryk/react-components';

import { patientMedicalInformationTranslationKeys } from '../../translations';

import { StyledMedicalInformationDescriptionPlaceholder } from './MedicalInformationDescriptionPlaceholder.styled';

type MedicalInformationDescriptionTextViewProps = {
   readonly description: string;
};

export const MedicalInformationDescriptionTextView = (
   props: MedicalInformationDescriptionTextViewProps
): JSX.Element => {
   return (
      <TextView label={patientMedicalInformationTranslationKeys.previewModal.description} testId={'description'}>
         {props.description || (
            <StyledMedicalInformationDescriptionPlaceholder>
               <Translate>{patientMedicalInformationTranslationKeys.lack}</Translate>
            </StyledMedicalInformationDescriptionPlaceholder>
         )}
      </TextView>
   );
};
